import { Checkbox, Tooltip } from '@mui/material';
import { Shield, ShieldOff } from 'lucide-react';
import { FormattedMessage } from 'react-intl';
import useSensitiveInfoReveal from '~/hooks/patient/useSensitiveInfoReveal';

const SensitiveInfoToggle = () => {
    const { isInfoShown, toggleWithGate } = useSensitiveInfoReveal();

    return (
        <Tooltip
            title={
                isInfoShown ? (
                    <FormattedMessage id="hidePatientLabelTooltip" />
                ) : (
                    <FormattedMessage id="showPatientInfoTooltip" />
                )
            }
            placement="left-start"
        >
            <Checkbox
                onChange={toggleWithGate}
                checked={!isInfoShown}
                inputProps={{
                    'aria-label': 'Show sensitive info',
                }}
                icon={<ShieldOff size={14} />}
                checkedIcon={<Shield size={14} />}
                size="small"
                sx={{
                    padding: 0.5,
                }}
                data-testid="patient-info-toggle"
            />
        </Tooltip>
    );
};

export default SensitiveInfoToggle;
